/**
 * 接口前缀
 */
export const PROXY_URL = '/api';

export const INTERFACE_ERROR = '服务器响应异常！';

export const VERSION = '1.0.0';

export const ACCESS_TOKEN = 'KSESSIONID';
export const SHIRO_COOKIE = 'SHIROSESSIONID';

export const appName = '';
export const appIntro = '';

export const INDEX_PATH = '/login';
/** 是否需要登录认证 */
export const AUTH = true;

/** 是否hash路由，true的时候是war包打包方式，false是ngnix单独部署方式以及开发环境 */
export const hashRouter = process.env.NODE_ENV === 'production' ? true : false;

/** 默认表格分页大小 */
export const defaultPageSize = 10;

/** 广告语 */
export const slogon = '气候脉搏，以数据丈量碳足迹，让碳中和触手可及！';

/** 一级分类 */
export const conversatonType = ['碳中和政策', '方法论', 'ESG', '绿色金融', '零碳园区', 'CCUS技术', '光伏储能', '国际双碳'];

/** 一级分类说明 */
export const conversatonTip = [
	'全球生物医药数据，包括药物、靶点、适应症、化合物、序列、临床试验、医药专利、交易、论文、新闻、FDA药品说明书、财报、招股书以及网络信息。',
	[
		'全球临床试验、临床结果、FDA药品说明书及网络信息。',
		'全球ESG报告及治理方案',
		'主要包含中国、美国的主要临床指南与医学共识，涵盖所有疾病方向。',
		'FDA药品说明书文件。',
		'A股/美股/港股生物医药公司财报及招股书。',
		'全球生物医药领域发明专利及网络信息。',
		'全球论文及网络信息。',
		'全球案例',
	],
];

export const visitorToken =
	'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ2aXNpdG9yIiwiZXhwIjo5MjIzMzcyMDM2ODU0Nzc1fQ.vHRHyU_GmppJ40y03MzzH_BjfcsU6oCOsbimniuhD4JVlW74HSb7QldIUPVya_FQSLg7eBltWTafqjf_LAVNiQ';

/** 问题示例 */
export const questionSamples = [
	[
		{ kind: '中金碳经济', sample: '《绿色金融行业：以引导促服务，化挑战为机遇》' },
		{ kind: 'CCER', sample: '碳中和系列深度报告：碳交易开启在即，CCER提供业绩弹性-广发证券' },
		{ kind: '碳交易', sample: '企业碳减排与碳交易知识问答' },
		{ kind: 'CCUS', sample: '中国碳捕集、利用与封存(CCUS)技术进展报告' },
	],
	[
		[
			{ kind: '基础理论', sample: '碳排放专业基础精讲讲义' },
			{ kind: '政策解读', sample: '碳质押干货：政策规范、案例汇总、深度研究' },
		],
		[
			{ kind: 'CCER', sample: '碳中和系列深度报告：碳交易开启在即，CCER提供业绩弹性-广发证券' },
			{ kind: '规范标准', sample: '碳资产管理体系资料包：规范案例、标准、管理办法编制指引' },
		],
		[
			{ kind: 'ESG报告', sample: '中金ESG手册：ESG热点聚焦' },
			{ kind: 'ESG理论', sample: 'ESG面试问题' },
		],
		[
			{ kind: '中金碳经济', sample: '《绿色金融行业：以引导促服务，化挑战为机遇》' },
			{ kind: '碳交易', sample: '企业碳减排与碳交易知识问答' },
		],
		[
			{ kind: '零碳园区案例', sample: '苏州工业园区近零碳园区建设路径研究摘要报告--苏州中咨工程咨询' },
			{ kind: '零碳学校', sample: '零碳学校是什么？' },
			{ kind: '零碳建筑', sample: '零碳建筑指南 — 实现零碳建筑建筑的三个步骤 ' },
		],
		[
			{ kind: 'CCUS', sample: '中国碳捕集、利用与封存(CCUS)技术进展报告' },
			{ kind: '双碳技术', sample: '绿色低碳技术专利分类体系' },
		],
		[
			{ kind: '光伏储能', sample: '光伏+储能的应用场景及盈利模式' },
			{ kind: '绿电', sample: '有关绿证的若干问题及解答' },
		],
		[
			{ kind: '资讯', sample: '瑞士2050年脱碳路径及建筑行业的相关政策-中国建筑节能协会' },
			{ kind: '政策', sample: '零碳建筑标准2.0版（英文版）-加拿大绿色建筑委员会' },
		],
	],
];

/** 个人知识库简介 */
export const knowledgeIntro =
	'上传相关文件，如理论文献、政策文件、行业报告、ESG报告、行业标准等，模型能够协助您理解文件内容，并提取图标和关键数据，请注意，系统正在不断优化中，对于报告、分析和图片内容的识别可能还不够精准，此外，请勿上传任何非公开资料，例如公司内部文件等。';

/** 个人知识库存储空间 */
export const totalStorage = 50;

export const loginSlogon = [
	// '将前人的创造积累化为前进的工具，助力你登临更高的山峰',
	// '深度剖析科创要素，全生命周期的营销服务平台，赋能科技金融服务',
	// '通过科技创新情报的端到端一站式解决方案，赋能创新主体数字化转型升级',
	// '利用AI技术和深加工数据，为研发创新者提供及时，全面，准确和易用的全球专利情报',
	'',
	// '一站式化学结构检索分析平台，致力加快化学领域',
	// '以最优算法检索生物序列，助力降低生物领域',
	// '利用AI技术，深度挖掘公司，药物，疾病和靶点间的关联，为药物研发和市场决策提供创新情报',
];

export const versionPrice = [
	{ versionType: 'free', name: '体验版', conversatonTime: 3, resetFreq: '每日', extraConversation: 3, knowledgeStorage: 0, fileUpload: 0, deepSeek: 0, visitWay: '网页访问' },
	{ versionType: '0', name: '基础版', conversatonTime: 10, resetFreq: '每日', extraConversation: 10, knowledgeStorage: 50, fileUpload: 5, deepSeek: 5, visitWay: '网页访问' },
	{
		versionType: '1',
		name: '专业版',
		conversatonTime: 50,
		resetFreq: '每日',
		extraConversation: 50,
		knowledgeStorage: 200,
		fileUpload: 200,
		deepSeek: 50,
		visitWay: '网页访问、IP段域名访问、SSO登录、专属售后',
	},
];

// 短信发送验证码间隔时间
export const sendFreuence = 60;
